<ng-template #defaultList>
  <div class="attributes-list">
    @for (attr of limitedAttributes; track trackByAttribute(index, attr); let index = $index) {
      <rt-tag
        [name]="attr.value"
        [deletable]="!isReadOnly && removableAttributes[attr.id!]"
        [disabled]="isReadOnly || attr.processing"
        (deleteClick)="delete.emit(attr)"
        [wrapText]="true"
        [isHoverable]="tagsHoverable"
        [isClickable]="tagsClickable"
        [attr.margin-top-small-xx]="(hasMarginTop && !hasSmallXXXMargins) || null"
        [attr.margin-bottom-small-xx]="!hasSmallXXXMargins || null"
        [attr.margin-top-small-xxx]="(hasMarginTop && hasSmallXXXMargins) || null"
        [attr.margin-bottom-small-xxx]="hasSmallXXXMargins || null"
        margin-right-small-xx
      ></rt-tag>
    }
    @if (itemsLimit && attributes.length > itemsLimit) {
      <rt-button
        [variant]="showMoreButtonVariant"
        size="small"
        (click)="toggleShowedOverLimit()"
        [attr.margin-bottom-small-xx]="hasMarginBottom && !hasSmallXXXMargins ? '' : null"
        [attr.margin-top-small-xx]="(hasMarginTop && !hasSmallXXXMargins) || null"
        [attr.margin-top-small-xxx]="(hasMarginTop && hasSmallXXXMargins) || null"
        [attr.margin-bottom-small-xxx]="(hasMarginBottom && hasSmallXXXMargins) || null"
        margin-right-small-xx
      >
        {{
          showedOverLimit
            ? ('rtu.common.show_less' | translate)
            : ('rtu.common.show_more_count' | translate: { count: attributes.length - itemsLimit })
        }}
      </rt-button>
    }
    @if (hasTrigger && (canPick || canCreate)) {
      <rt-icon-button
        #origin="rtOverlayOrigin"
        rt-overlay-origin
        (click)="toggleDropdown(origin)"
        [pressed]="dropdown.open"
        [variant]="triggerIconButtonVariant"
        iconName="add"
        shape="square"
        size="small"
        [disabled]="isReadOnly"
        [attr.margin-top-small-xx]="(hasMarginTop && !hasSmallXXXMargins) || null"
        [attr.margin-top-small-xxx]="(hasMarginTop && hasSmallXXXMargins) || null"
        [attr.margin-bottom-small-xx]="hasMarginBottom && !hasSmallXXXMargins ? '' : null"
        [attr.margin-bottom-small-xxx]="hasMarginBottom && hasSmallXXXMargins ? '' : null"
      />
    }
  </div>
</ng-template>

<ng-container *ngTemplateOutlet="listTemplate; context: listContext"></ng-container>

<ng-template
  #dropdown="rtConnectedOverlay"
  [positions]="dropdownPositions"
  [hasBackdrop]="dropdownAutoCloseOnUnpreventedClick"
  (backdropClick)="onBackdropClick(dropdown.origin)"
  rt-connected-overlay
>
  <rt-attributes-select
    [text]="attributesTexts"
    [showAlreadyExists]="attributeAlreadyExists"
    [resetOnSaveFromInput]="resetOnSaveFromInput"
    [resetOnSaveFromSuggestion]="resetOnSaveFromSuggestion"
    [loading]="suggestionsData.isLoading"
    [width]="hasTriggerWidth ? getTriggerWidth() : '300px'"
    [canPick]="canPick"
    [canCreate]="canCreate"
    [createDisabled]="createDisabled"
    [maxDropdownHeight]="maxDropdownHeight"
    [suggestions]="suggestionsData"
    [initialValue]="initialValue"
    [maxLength]="maxLength"
    [selectFooterTemplate]="selectFooterTemplate"
    [selectHeaderTemplate]="selectHeaderTemplate"
    [hasSearch]="hasSearch"
    [control]="control"
    [selected]="attributes"
    [markSelected]="markSelected"
    (save)="save.emit($event)"
    (query)="handleQueryChange($event)"
    (dispose)="toggleDropdown(dropdown.origin)"
    (loadMore)="loadMore.emit($event)"
  >
  </rt-attributes-select>
</ng-template>
